import type { HSLColor } from "../types/colors/HSLColor"
import type { RGBColor } from "../types/colors/RGBColor"
import { Abs, Max, Min } from "../math/Math"

/**
 * Converts RGB color to HSL color
 * Assumes RGB values are in range 0-1
 */
export const RgbToHsl = (rgb: RGBColor): HSLColor => {
  const { a, b, g, r } = rgb

  // Find the maximum and minimum values to calculate saturation
  const max = Max(r, g, b)
  const min = Min(r, g, b)
  const delta = max - min

  // Calculate lightness
  const l = (max + min) / 2

  // Calculate saturation
  let s = 0
  if (delta !== 0) {
    s = delta / (1 - Abs(2 * l - 1))
  }

  // Calculate hue (0-1)
  let h = 0
  if (delta !== 0) {
    if (max === r) {
      h = ((g - b) / delta) % 6
    } else if (max === g) {
      h = (b - r) / delta + 2
    } else {
      h = (r - g) / delta + 4
    }

    h /= 6 // Normalize to 0-1
    if (h < 0) h += 1
  }

  return { a, h, l, s }
}
